const defaultFilteringValue = {
  id: 0,
  name: 'Employees',
  displayName: 'Employees'
};

export default defaultFilteringValue;
